import React, { useState } from "react"
import { Col, Card, CardBody, Button } from "reactstrap"
import ReactApexChart from "react-apexcharts"
import * as moment from "moment"

const ProductSaleGraph = props => {
  //console.log('Series:'+JSON.stringify(props.series))
  /*
  const series = [
    {
      name: "Sales",
      data: [],
    },
  ]*/

  const [options, setOptions] = useState({
    chart: { 
      toolbar: {
        show: true,
      }, 
    },
    dataLabels: { enabled: 1 },
    stroke: { curve: "smooth", width: 2 },
    markers: { size: 0, style: "hollow" },
    xaxis: {
      type: "datetime",
      min: moment(new Date()).subtract(30, 'days').valueOf(), //const todayStart = moment(new Date()).subtract(30, 'days').valueOf()
      max: moment(new Date()).valueOf(),
      //tickAmount: 6,
    },
    tooltip: { x: { format: "dd MMM yyyy" } },
    colors: ["#184e77"],
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.6,
        opacityTo: 0.05,
        stops: [42, 100, 100, 100],
      },
    },
  })

  const [activeM, setactiveM] = useState(true)
  const [active6M, setactive6M] = useState(false)
  const [activeY, setactiveY] = useState(false)
  const [activeA, setactiveA] = useState(false)

  const updateChartMonthly = () => {
    var newxaxis = {
      min: moment(new Date()).subtract(30, 'days').valueOf(),
      max: moment(new Date()).valueOf(),
    }
    const modifiedOptions = {
      ...options,
      xaxis: newxaxis,
    }
    setOptions(modifiedOptions)
    setactiveM(true)
    setactive6M(false)
    setactiveY(false)
    setactiveA(false)
  }

  const updateChartSixMonth = () => {
    var newxaxis = {
      min: moment(new Date()).subtract(182, 'days').valueOf(),
      max: moment(new Date()).valueOf(),
    }
    const modifiedOptions = {
      ...options,
      xaxis: newxaxis,
    }
    setOptions(modifiedOptions)
    setactiveM(false)
    setactive6M(true)
    setactiveY(false)
    setactiveA(false)
  }

  const updateChartYearly = () => {
    var newxaxis = {
      min: moment(new Date()).subtract(365, 'days').valueOf(),
      max: moment(new Date()).valueOf(),
    }
    const modifiedOptions = {
      ...options,
      xaxis: newxaxis,
    }
    setOptions(modifiedOptions)
    setactiveM(false)
    setactive6M(false)
    setactiveY(true)
    setactiveA(false)
  }

  const updateChartAll = () => {
    var newxaxis = { min: void 0, max: void 0 }
    const modifiedOptions = {
      ...options,
      xaxis: newxaxis,
    }
    setOptions(modifiedOptions)

    setactiveM(false)
    setactive6M(false)
    setactiveY(false)
    setactiveA(true)
  }

  return (
    <React.Fragment>
      <Col>
        <Card>
          <CardBody>
            <h4 className="card-title mb-3">Sales Summary</h4>
            <div>
              <div id="overview-chart" className="apex-charts" dir="ltr">
                <div className="toolbar button-items text-center">
                  <Button
                    color="light"
                    size="sm"
                    type="button"
                    className={activeM ? "active" : ""}
                    onClick={() => updateChartMonthly()}
                    id="one_month"
                  >
                    1M
                  </Button>
                  <Button
                    color="light"
                    size="sm"
                    type="button"
                    className={active6M ? "active" : ""}
                    onClick={() => updateChartSixMonth()}
                    id="six_months"
                  >
                    6M
                  </Button>
                  <Button
                    color="light"
                    size="sm"
                    type="button"
                    className={activeY ? "active" : ""}
                    onClick={() => updateChartYearly()}
                    id="one_year"
                  >
                    1Y
                  </Button>
                </div>
                <div id="overview-chart-timeline">
                  <ReactApexChart
                    options={options}
                    series={props.series}
                    type="area"
                    height={240}
                  />
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  )
}

export default ProductSaleGraph
